var React = require('react');

function V (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#60BC57","fillRule":"evenodd","d":"M.427 5.17l3.476 2.616a1.06 1.06 0 0 0 1.489-.212l4.392-5.846A1.087 1.087 0 0 0 9.6.236L9.58.218a1.06 1.06 0 0 0-1.495.209l-3.75 4.995-2.628-1.973a1.058 1.058 0 0 0-1.493.216 1.086 1.086 0 0 0-.203.793c.04.287.19.544.417.713z"}));
}

V.defaultProps = {"width":"14","height":"12","viewBox":"0 0 14 12"};

module.exports = V;

V.default = V;
